module.exports = __webpack_public_path__ + "static/media/keuangan.0a6a2b0a.png";